import { userFilterCategories } from "../../../shared/lookup";
const workflows = [
    {
        id: 77,
        title: '$PM_NAME Assessments',
        notificationName: 'Assessment',
        abbreviation: '$PM_ABBREVIATION-Other-Assessment',
        notifyingParty: 'PM',

        notify: true,
        financialLimitEnabled: false,
        assetFieldsEnabled: false,

        form_IncludeCompanyName: false,
        form_CompanyName: 'PARTY',
        form_CompanyLogo: 'PARTY',

        notifyAttachments: true,

        includePdfjson: false,

        config: {
            description: 'PM Assessments',
            currentModel: 'Assessment',
            currentModelType: 'PM',
            referenceType: 'Assessment',
            documentType: 'DocumentAssessmentPM',


            showInRelations: true,
            showInCustomFields: true,
            notifyPossible: true,
            replyPossible: false,
            configurableFinancialLimit: true,
            configurableAssets: true,

            userFilterCategories: [
                userFilterCategories.ACCESS,
                userFilterCategories.MAIN_NOTICE,
                userFilterCategories.NOTIFY
            ],
            paths: {
                base: 'pm',
                create: 'create',
                list: 'list',
                default: 'list'
            }
        }
    },
]

export default workflows;